export default __webpack_public_path__ + "9b5ce4f2bc643b54b6a4795f86084c48.jpg";